export default function getStepsFromStoleMetaJson(stoleMeta, callback) {
	let stepNames = [];
	const stepperData = (stoleMeta && stoleMeta.stepper) || null;
	stepperData && Object.entries(stepperData).forEach(([key, value]) => {
		stepNames.push(value);
	});
	const stepArr = stepNames.map((stepName, index) => ({
		title: stepName,
		onClick: (e) => {
			e.preventDefault();
			callback(index + 1);
		},
	}));

	return stepArr;
}
